import { render, staticRenderFns } from "./inactivos.vue?vue&type=template&id=6c362b86&"
import script from "./inactivos.vue?vue&type=script&lang=js&"
export * from "./inactivos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports